const barColors = [
  "#284894",
  "#E49A46",
  "#E8E8E8"
];


const graphs = document.querySelectorAll(".c-box-chart__block");


for (var i = 0; i < graphs.length; i++) {

  const target = graphs[i];
  const list = target.querySelector(".c-box-chart__legend");
  const inputs = target.querySelectorAll("input[type='hidden']");
  const {xValues, yValues} = getInputData(inputs);
  const chartId = target.querySelector("canvas").id;

  initChart(chartId, xValues, yValues);
  initLegend(xValues, yValues, list);
}

function getInputData(inputs) {
  const xValues = [];
  const yValues = [];

  for (var i = 0; i < inputs.length; i++) {
    xValues.push(inputs[i].name);
    yValues.push(inputs[i].value)
  }

  return {
    xValues,
    yValues
  }
}

function initLegend(xValues, yValues, list) {
  for (var i = 0; i < xValues.length; i++) {
    const item = document.createElement("li");
    item.classList.add("c-box-chart__item");
    item.innerHTML = xValues[i];
    if (i === 1) {
      item.classList.add("is-second");
    } else if (i === 2) {
      item.classList.add("is-third");
    }
    list.appendChild(item);
  }
}

function initChart(chartId, xValues, yValues) {
  new Chart(chartId, {
    type: "pie",
    data: {
      labels: xValues,
      datasets: [{
        backgroundColor: barColors,
        data: yValues,
        borderWidth: 0
      }]
    },
    options: {
      responsive: false,
      aspectRatio: 1,
      legend: {
        display: false,
      },
      plugins: {
        labels: {
          render: 'persentage',
          precision: 0,
          showZero: true,
          fontSize: 13,
          fontColor: function (data) {

            if (data.dataset.data.length > 2) {
              const min = Math.min(...data.dataset.data);

              if (parseInt(data.value) === min) {
                return "#666666";
              }
            }
            return "#fff";
          },
          fontStyle: 'normal',
          fontFamily: "'Noto Sans JP', sans-serif, 'Helvetica', 'Arial'",
          textShadow: false,
          arc: false,
          position: 'default',
          align: 'top',
          offset: 100,
          overlap: true,
          showActualPercentages: true
        }
      },
      tooltips: {
        callbacks: {
          label: function(tooltipItem, data) {
            return data.labels[tooltipItem.index];
          }
        }
      },
    }
  });
}



const bars = document.querySelectorAll(".c-card-houses__bar-inner");


for (var i = 0; i < bars.length; i++) {

  const target = bars[i];
  const bar = target.querySelector(".c-card-houses__bar");
  const labels = target.querySelector(".c-card-houses__bar-labels");
  const inputs = target.querySelectorAll("input[type='hidden']");
  const barData = getBarData(inputs);
  setBars(barData, bar, labels);
}

function getBarData(inputs) {
  const data = [];
  for (var i = 0; i < inputs.length; i++) {
    const item = inputs[i];
    const { name, value } = item;
    data.push({name, value});
  }
  return data;
}

function setBars(data, bar, labels) {
  for (var i = 0; i < data.length; i++) {
    const {name, value} = data[i];
    const line = document.createElement("span");
    line.style.width = `${parseInt(value)}%`;
    const label = document.createElement("li");
    label.classList.add("c-card-houses__bar-label");
    label.innerHTML = name;
    labels.appendChild(label);
    bar.appendChild(line);
  }
}
